import * as React from 'react';
import { Subtract } from 'utility-types';

export interface IWithCountryProps {
  country: string;
}

const withCountry = <P extends IWithCountryProps>(
  Component: React.ComponentType<P>
): React.SFC<Subtract<P, IWithCountryProps>> => props => {
  let country = 'global';
  const subdomain = window.location.href.split('//')[1].split('.')[0];
  if (
    ['f5wc'].indexOf(subdomain) === -1 &&
    !subdomain.includes('localhost') &&
    !subdomain.includes('192')
  ) {
    country = subdomain;
  }

  return <Component {...props} country={country} />;
};

export default withCountry;



// WEBPACK FOOTER //
// ./src/enhancers/withCountry.tsx